// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mind-map"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 10H9V14H3V10Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 3H21V7H15V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 17H21V21H15V17Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 5H10C7.79086 5 6 6.79086 6 9V10M15 19H10C7.79086 19 6 17.2091 6 15V14M6 14H9V10H6M6 14H3V10H6M15 3H21V7H15V3ZM15 17H21V21H15V17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MindMapIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mind-map',
    ref,
    icon: element,
  },
));

MindMapIcon.displayName = 'MindMapIcon';

export default MindMapIcon;
